import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { Pagination } from '~/Api/Pagination';
import {
	BrandsQuery,
	fetchMoreHistory,
	pruneHistory,
	Record,
	selectHistory,
	State as HistoryState,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/History';
import { ThunkDispatch } from '~/Store';

import HistoryPanel from './HistoryPanel';

interface State {
	medicinalBrandsAnalyticsHistory: HistoryState;
}

interface OwnProps {
	query: BrandsQuery;
}

function mapStateToProps(
	{ medicinalBrandsAnalyticsHistory }: State,
	{ query }: OwnProps
): {
	history: Record[] | null;
	pagination: Pagination | null;
	isFetching: boolean;
} {
	const historyState = selectHistory(medicinalBrandsAnalyticsHistory, query);

	return {
		history: historyState?.items || null,
		pagination: historyState?.pagination || null,
		isFetching: historyState?.isFetching ?? false,
	};
}

function load(query: BrandsQuery) {
	return (dispatch: ThunkDispatch<AnyAction>) => {
		if (query.isValid) {
			dispatch(fetchMoreHistory(query, 50));
		}
	};
}

function unload(query: BrandsQuery) {
	return (dispatch: ThunkDispatch<AnyAction>) => {
		dispatch(pruneHistory(query));
	};
}

const actions = {
	onLoad: load,
	onUnload: unload,
};

export default connect(mapStateToProps, actions)(HistoryPanel);
